import create from './create';
import get from './get';
import getOne from './getOne';
import del from './del';
import edit from './edit';
import countAll from './countAll';
import count from './count';
import print from './print';
import createEvent from './createEvent';

export default {
  create,
  get,
  getOne,
  del,
  edit,
  countAll,
  count,
  print,
  createEvent,
};



// WEBPACK FOOTER //
// ./src/services/order/index.js